var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"previewPic"},[_c('image-viwe',{attrs:{"onClose":_vm.handleCloseImgView,"urlList":[_vm.picInfo.imgUrl]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }